// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  versionCheckURL : '/version.json',

  recaptcha: {
    siteKey: '6Lcz2AUaAAAAAFmA85iTpCtCuCZCTSqTuFi0sZfq'
  },
  api: {
    baseUrl: 'https://pricing-api.glichealth.com/api/v3/',
    payloadSecret: 'aca*GJK63e&jaabs@xF5#22jsdlk&gtd%$D9',
    version: 'v3',
    timeout: 30000,
    retryAttempts: 3,
    enableLogging: true
  },
  googleMaps: {
    // TODO: Replace with your actual Google Maps JavaScript API key
    apiKey: 'AIzaSyBNihkxqgTOPI88D4-CfGUz-lOvtu_ceaA'
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
